/**
 * Dont use Media type for OCR type
 */
export enum OcrType {
    /**
     * For vehicle number plate
     */
    vrn = 'vrn',
    
    /**
     * For vehicle odo and soc dashboard
     */
    dashboard = 'dashboard',
}
